export function AiScreeningCallSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/ai-screening-call.svg'"></ng-include>`
    }
}